import { Component, OnInit, inject } from "@angular/core";
import { LanguageModel } from '@app/shared/dialog/select-lang/language.model';
import { InspektTranslateService } from "@app/core/translation/inspekt-translate.service";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";

@Component({
    selector: "inspekt-select-lang",
    templateUrl: "./select-lang.component.html",
    styleUrls: ["./select-lang.component.scss"],
    imports: [MatDialogModule, MatButtonModule],
})
export class SelectLangComponent implements OnInit {
    dialog = inject(MatDialog);
    private translate = inject(InspektTranslateService);

    public supportedLanguages: LanguageModel[];

    ngOnInit(): void {
        this.supportedLanguages = this.translate.supportedLanguages;
    }

    openDialog(): void {
        this.dialog.open(SelectLangComponent, {
            width: "250px",
        });
    }

    selectLanguage(lang: LanguageModel) {
        this.translate.use(lang.code);
    }
}
